"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTheme = exports.useTheme = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _basis = require("basis");

var _emotionTheming = require("emotion-theming");

var _core = require("@emotion/core");

var _context = require("../context");

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useTheme = function useTheme() {
  return (0, _emotionTheming.useTheme)();
};

exports.useTheme = useTheme;

var getTheme = function getTheme(theme) {
  // Please note: this is not region specific default config
  var defaultConfig = (0, _context.getDefaultConfig)();

  var _ref = theme || {},
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? defaultConfig.theme.bgColor : _ref$bgColor,
      _ref$inputColor = _ref.inputColor,
      inputColor = _ref$inputColor === void 0 ? defaultConfig.theme.inputColor : _ref$inputColor,
      _ref$highlightColor = _ref.highlightColor,
      highlightColor = _ref$highlightColor === void 0 ? defaultConfig.theme.highlightColor : _ref$highlightColor,
      _ref$headingColor = _ref.headingColor,
      headingColor = _ref$headingColor === void 0 ? defaultConfig.theme.headingColor : _ref$headingColor,
      _ref$headingSize = _ref.headingSize,
      headingSize = _ref$headingSize === void 0 ? defaultConfig.theme.headingSize : _ref$headingSize;

  return {
    basis: _objectSpread({}, _basis.defaultTheme),
    // add any custom theme props here
    bgColor: bgColor,
    inputColor: inputColor,
    highlightColor: highlightColor,
    headingColor: headingColor,
    headingSize: headingSize,
    media: {
      max: Object.keys(_basis.defaultTheme.breakpoints).reduce(function (acc, key) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, key, function () {
          return (0, _core.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n            @media only screen and (max-width: ", ") {\n              ", "\n            }\n          "])), _basis.defaultTheme.breakpoints[key], _core.css.apply(void 0, arguments));
        }));
      }, {}),
      min: Object.keys(_basis.defaultTheme.breakpoints).reduce(function (acc, key) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, key, function () {
          return (0, _core.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n            @media only screen and (min-width: ", ") {\n              ", "\n            }\n          "])), _basis.defaultTheme.breakpoints[key], _core.css.apply(void 0, arguments));
        }));
      }, {})
    }
  };
};

exports.getTheme = getTheme;